module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bundleSupport":"EDI message bundle?"},"no":{"bundleSupport":"Bundling av edi meldinger?"}}')
  delete Component.options._Ctor
}
